import React from 'react';

// Classnames
import clsx from 'clsx';

// Style
import './PaginationView.scss';

// Style
import { styleFieldSelectSize } from 'constans/react-select-style';

// Components
import GoTo from 'components/UiKit/GoTo';
import Button from 'components/UiKit/Button';
import Pagination from 'components/UiKit/Pagination';
import FieldSelect from 'components/UiKit/FieldSelect';

// Type
type TOptionsSize = {
	label: string;
	value: number;
};
type TFuncArgs = {
	[index: string]: number;
};

// Interface
interface IPaginationView {
	labelForSelect?: string;

	className?: string;

	isWhite?: boolean;
	isShowSelect?: boolean;

	goTo: number | undefined;
	handlerSubmitGoTo: () => void;
	onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	handlerChangeGoTo: (e: React.ChangeEvent<HTMLInputElement>) => void;

	number: number | undefined;
	totalPages: number | undefined;
	onNextPressLast: () => void;
	onPrevPressLast: () => void;
	onPagePress: (page: number) => void;

	optionsSize?: TOptionsSize[];
	valueSize?: any;
	handlerChangeSize?: (data: TFuncArgs) => void;

	children?: React.ReactNode;
}

export const PaginationView: React.FC<IPaginationView> = (props) => {
	const {
		children,

		labelForSelect = 'Number of compounds',

		className,

		isWhite,
		isShowSelect,

		goTo,
		onKeyPress,
		handlerSubmitGoTo,
		handlerChangeGoTo,

		number,
		totalPages,
		onPagePress,
		onNextPressLast,
		onPrevPressLast,

		valueSize,
		optionsSize,
		handlerChangeSize
	} = props;

	const cn = clsx(
		'pagination-view flex flex-ai-center flex-jc-between flex-direction-column-desktop',
		className ? className : ''
	);

	return (
		<div className={cn}>
			<div className="pagination-view__left-block flex flex-ai-center">
				{isShowSelect && <FieldSelect
					name="size"
					isWhiteArrow
					value={valueSize}
					placeholder="Size"
					options={optionsSize}
					label={labelForSelect}
					onChange={handlerChangeSize}
					styles={styleFieldSelectSize}
					className="mr10 flex flex-ai-center"
					classNameLabel="pagination-view__select-size mr20"
				/>}
				{children}
			</div>
			<div className="pagination-view__rigth-block flex flex-ai-center flex-jc-center">
				<div className="pagination-view__button-block-go-to flex flex-ai-center flex-jc-center flex-direction-row-mobile">
					<GoTo
						name="goTo"
						value={goTo || 0}
						isWhite={isWhite}
						classNameLabel="mr20"
						onKeyPress={onKeyPress}
						handlerChange={handlerChangeGoTo}
						className="mr20 pagination-view__button-go-to"
					/>
					<Button
						label="Go"
						variable="info"
						onPress={handlerSubmitGoTo}
						className="mr20 pagination-view__button-go"
					/>
				</div>
				<Pagination
					isWhite={isWhite}
					total={(totalPages || 0)}
					onPagePress={onPagePress}
					onNextPressLast={onNextPressLast}
					onPrevPressLast={onPrevPressLast}
					currentPage={number !== 0 ? ((number || 0) + 1) : 1}
					onPrevPress={() => onPagePress(((number || 0) + 1) - 1)}
					onNextPress={() => onPagePress(((number || 0) + 1) + 1)}
				/>
			</div>
		</div>
	);
};

export default PaginationView;
